<template>
<div class='general'>
    <smallbutton :toplabel="title" @click="Start()"  />
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form >
                <div class="rightjustified">
                    <smallbutton @click="close()" toplabel='X' buttonclass="buttonclose" />
                </div>
                <label class="titlelabel">{{title}}</label>

                <!-- select one -->
                <div class="entry" v-if="!inEdit">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="">Select Badge Information to Edit</label>
                    </div>
                    <div>
                        <select name="" id="" class='entrySelect' v-model="selectedItem" @change="SelectMyItem">
                            <option v-for="item in itemListFiltered" :key="item.id" :value="item.id" >
                                {{item.name}}
                            </option>
                        </select>
                        <div class="horizFlex">
                            <div class="entrycheck">
                                <input  type="checkbox"  v-model="includeInactive" />
                            </div>
                            <div class="entryTextDiv">
                                <label class="inactivelabel" for="">Include Inactive</label>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div>
                    <label v-if="pleaseWait" class="pleasewait">Please Wait...</label>
                </div>

                <div v-if="!inEdit">
                    <smallbutton  @click="update()" toplabel="Update"  :disabled="!currentIsActive"/>
                    <smallbutton  @click="add()" toplabel="Add" />
                    <smallbutton  @click="activate()" :toplabel="activateText" :disabled="selectedItem<=0" />
                    <!-- <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close Manager"/> -->
                </div>
                <div v-if="inEdit" class="mainform">
                    <div class="col">
                        <formentry label="Name" isrequired='True' v-model="currentItem.name" maxlength="100" />
                        <formentry label="Website"  v-model="currentItem.website" maxlength="100"/>
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Is Menu Item</label>
                            </div>
                            <div class="entrycheck">
                            <input type="checkbox"  v-model="currentItem.isMenuItem" />
                            </div>
                        </div>
                        <hr>

                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Is Contact</label>
                            </div>
                            <div class="entrycheck">
                                <input  type="checkbox"  v-model="currentItem.isContact" />
                            </div>
                            
                        </div>
                        <formentry label="Phone Number" inputtype="tel" v-model="currentItem.phoneNumber" :disabled="!currentItem.isContact"/>
                        <formentry label="Email Address" inputtype="email" v-model="currentItem.emailAddress" :disabled="!currentItem.isContact"/>
                        <hr>

                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Is Info Item</label>
                            </div>
                            <div class="entrycheck">
                            <input type="checkbox"  v-model="currentItem.isInfoItem" />
                            </div>
                        </div>
                        <!-- <formentry label="Information Text" v-model="currentItem.infoText" :disabled="!currentItem.isInfoItem"/> -->

                        <div class="entry">    
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Information Text</label>
                            </div>
                            
                            <textarea class="entrymulti"   v-model="currentItem.infoText" rows="2" cols="20"/>
                        </div>
                        <!-- <formentry label="HTML Text"  v-model="currentItem.htmlText" :disabled="!currentItem.isInfoItem"/> -->
                        <div class="entry">    
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">HTML Text</label>
                            </div>
                            
                            <textarea class="entrymulti"   v-model="currentItem.htmlText" rows="2" cols="20"/>
                        </div>
                        <hr>
                        
                        
                     <!--    <formentry label="Ordinal"  v-model="currentItem.ordinal" />
                        <formentry label="Restrict to Badge ID"  v-model="currentItem.restrictToBadgeId" /> -->
                        
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Applies to Location</label>
                            </div>
                            <select name="" id="" class='entrySelect' v-model="currentItem.locationId">
                                <option v-for="location in locations" :key="location.id" :value="location.id" >
                                    {{location.name}}
                                </option>
                            </select>
                        </div>
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Applies to Department</label>
                            </div>
                            <select name="" id="" class='entrySelect' v-model="currentItem.departmentId" >
                                <option v-for="department in departments" :key="department.id" :value="department.id" >
                                    {{department.name}}
                                </option>
                            </select>
                        </div>
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Applies to Role</label>
                            </div>
                            <select name="" id="" class='entrySelect' v-model="currentItem.restrictToPersonRoleId" >
                                <option v-for="role in personRoleList" :key="role.id" :value="role.id" >
                                    {{role.name}}
                                </option>
                            </select>
                        </div>


                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Effective Date</label>
                            </div>
                            <input type="date" class="entrySelect"  v-model="currentItem.effectiveDate" />
                        </div>
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Expiration Date</label>
                            </div>
                            <input type="date" class="entrySelect"  v-model="currentItem.expirationDate" />
                        </div>
                        <formentry label="Ordinal" inputtype="number" v-model="currentItem.ordinal" />
                        <hr>
                         <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Can Be Edited</label>
                            </div>
                            <div class="entrycheck">
                            <input type="checkbox"  v-model="currentItem.canBeEdited" />
                            </div>
                        </div>

                    
                    </div>
  
                </div>
                <div v-if="inEdit">
                    <smallbutton  @click="save()" toplabel="Save" />
                    <smallbutton  @click="cancel()" toplabel="Cancel" />
                </div>

                <div>
                    <label class="responsemessage">{{message}}</label>
               </div>
          </form>

            
            <actionmodal ref="activateModal"> 
                <template v-slot:body>
                    <label >Do you want to {{activateText}} the selected Item?</label>
                    <div>
                        <smallbutton   @click="finishActivate()" :toplabel="activateText"/>
                        <smallbutton  @click="$refs.activateModal.closeModal()" toplabel="Cancel"/>
                    </div>
                </template>
            </actionmodal>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import datamethods from '../../datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import actionmodalwide from '../controls/actionmodalwide.vue'
import formentry from '../controls/entry.vue'
import imagecapture from '../controls/ImageCapture.vue'
import linkbutton from '../controls/linkbutton.vue'
import colorpicker from '../controls/colorpicker.vue'
import entrycolor from '../controls/entrycolor.vue'

export default {
    name:'badgeinfoadmin',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        imagecapture,
        linkbutton,
        colorpicker,
        entrycolor,
        actionmodalwide,
     
    },
    props:{

        
    },
    mixins:[datamethods,format],
    data(){
        return{
            
            inEdit:false,
            selectedItem:-1,
            currentItem:{},
            message:'',
            itemList:[],
            departments:[],
            locations:[],
            personRoleList:[],

            pleaseWait:false,
            multirows:2,
            includeInactive:false
        }
    },
        
    computed:{
        ...mapFields([
            'loggedIn',
        ]),
        title(){
            if(this.inEdit){
                if(this.currentItem.name==null){
                    return "Add Badge Information"
                }else{
                    return "Update " + this.currentItem.name
                }
            }else{return 'Badge Information'}
            
        },
        activateText(){
            if(this.currentItem.isActive){return "Deactivate"}
            else{return "Activate"}
        },
        currentIsActive(){
            return this.currentItem.isActive
        },
        itemListFiltered(){
            if(this.includeInactive){
                return this.itemList
            }else{
                let temp = this.itemList;
                if(temp!=undefined){
                    temp = temp.filter((item)=>{
                        
                        return(item.isActive)
                           
                    })
                }
                
                return temp;
            }
        }
    },
    methods:{
        handleAuthResponse(){
            if(this.message.includes('You are not authorized')){this.loggedIn=false}
        },
        close(){
            this.message=''
            this.inEdit=false
            this.$emit('refresh')
            this.$refs.mymodal.closeModal()
        },
       


      
        async Start(){
            this.GetItemList();
            this.getPersonRoleList();
            this.getDepartments();
            this.getLocations();
            this.$refs.mymodal.openModal()
        },
        update(){
            if(this.selectedItem<=0){return}

           // this.SelectMyItem()
            //start edit
            this.inEdit=true
        },
        add(){
            this.selectedItem=-1
            this.GetNewItem();
            //start edit
            this.inEdit=true
        },
        activate(){
            this.$refs.activateModal.openModal()
        },
        finishActivate(){
            this.currentItem.isActive = !this.currentItem.isActive
            this.currentItem.name.replace(' (Inactive)','')
            this.save()
            this.$refs.activateModal.closeModal()
        },
        async save(){
           if(!this.currentItem.isMenuItem && !this.currentItem.isInfoItem){
               this.message="Please check either Is Menu Item or Is Info Item"
               return
           }
            let req = {
                badgeInformation:this.currentItem
            }
            this.message=""
            this.pleaseWait=true;
            var response = await this.callAPI(req,'savebadgeinfo')
            if(response.Successful){
                this.selectedItem=response.ResponseInteger
                this.currentItem.id=response.ResponseInteger
                this.inEdit=false
                this.GetItemList()
            }else{
                this.message = response.Message
                this.handleAuthResponse()
                
            }
            this.pleaseWait=false;
        },
        cancel(){
            this.message=''
            this.inEdit=false
        },
        async SelectMyItem(){
            var currentid = this.selectedItem
            var sel
            this.itemList.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                let a=arr[index]
                if(a.id==currentid){
                    sel=a
                }
            }     
            this.currentItem=sel

      
            //defaults
            if(this.currentItem.departmentId==0){this.currentItem.departmentId=-1}
            if(this.currentItem.restrictToPersonRoleId==0){this.currentItem.restrictToPersonRoleId=-1}

            //format dates
            console.log(this.currentItem.effectiveDate )
            if(this.currentItem.effectiveDate.includes('0001-01-01')){this.currentItem.effectiveDate=null}
            if(this.currentItem.expirationDate.includes('0001-01-01')){this.currentItem.expirationDate=null}
            if(this.currentItem.effectiveDate!=null ){this.currentItem.effectiveDate = this.$options.filters.formatDateForInput(this.currentItem.effectiveDate)}
            if(this.currentItem.expirationDate!=null){this.currentItem.expirationDate = this.$options.filters.formatDateForInput(this.currentItem.expirationDate)}
            console.log(this.currentItem.effectiveDate )
                
     
        },
        GetNewItem(){
            console.log(this.currentItem)
            this.currentItem={
                id:-1,
                name:null,
                infoText:null,
                phoneNumber:null,
                emailAddress:null,
                website:null,
                restrictToBadgeId:null,
                restrictToPersonRoleId:-1,
                effectiveDate:null,
                expirationDate:null,
                isContact:false,
                isMenuItem:false,
                isInfoItem:false,
                ordinal:0,
                canBeEdited:false,
                departmentId:-1,
                isActive:true,
                locationId:-1,
            }
            
        },
        
        async GetItemList(){
            this.message=""
            this.pleaseWait=true;
            //call api
            var response = await this.callAPI(null,'badgeinfolist')
            //handle response
            if(response.Successful){
                this.itemList=response.BadgeInformationList

                //show which are inactive
                this.itemList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let a=arr[index]
                    if(!a.isActive){
                        a.name = a.name + " (Inactive)"
                    }
                } 

            }else{
                this.message = response.Message
                this.handleAuthResponse()
            }
            this.pleaseWait=false;
        },
        
        async getPersonRoleList(){
            this.message=""
            //call api
            var response = await this.callAPI(null,'rolelist')
            //handle response
            this.tmpresp = response
            if(response.Successful){
                this.personRoleList=response.PersonRoleList
            }else{
                this.message = response.Message
                this.handleAuthResponse()
            }
        },
        async getDepartments(){
            this.message=""
            //call api
            var response = await this.callAPI(null,'departmentlist')
            //handle response
            this.tmpresp = response
            if(response.Successful){
                this.departments=response.DepartmentList
            }else{
                this.message = response.Message
                this.handleAuthResponse()
            }
        },
        async getLocations(){
            this.message=""
            //call api
            var response = await this.callAPI(null,'locationlist')
            //handle response
            this.tmpresp = response
            if(response.Successful){
                this.locations=response.institutionLocationList
            }else{
                this.message = response.Message
                this.handleAuthResponse()
            }
        },
    },

}
</script>

<style>
.mainform{
    
}
.general{
    font-size:medium;
}
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
.imgbutton{
    background-color:var(--button-color);
    color:var(--light-text-color);
    border: none;
    border-radius:10px;
    min-width:130px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
  position:relative;
}
.imgbutton:hover{
    background-color:var(--highlight-color);
  cursor:pointer;
}
.icondiv{
    background-color:blue;
    background:transparent;
}
.icon{
    background:transparent;
    max-width: 250px;;
}
.col{
    padding:20px;
}
.entrycheck{
    text-align: left;
    width:100%;
    margin-top:7px;
    margin-bottom:7px;
}
.entrymulti{
    visibility: visible;
    font-size:inherit;
    margin:0px 5px 0px 5px;
    
    text-align:left;
    resize:none;
    min-height:50px;
    width:100%;
}
</style>





























